export default function PrivacyPolicy() {
  return (
    <iframe
      src={`/htm/privacyPolicy.html`}
      style={{ width: '100vw', height: '100vh', border: 'none' }}
    ></iframe>
  )
}
